import React from 'react';

import { AppProvider } from './context/AppProvider';

import { TOKEN, TYPE, STUDENT_ID, COMPONENT, DRILL_TITLE, FILE_LINK, FILE_LINK_LABEL, MB_TITLE, VIDEO_URL, VIDEO_BUTTON_LABEL, MASTERY_CARD_LABEL, MASTERY_CARD_POPUP_LABEL } from './constants';

import MasteryDashboard from './components/MasteryDashboard';

import DrillTeam from './pages/DrillTeam';

import MasteryBank from './pages/MasteryBank';
import WallOfFame from './components/WallOfFame';
import GridLayout from './components/gridLayout';

type ComponentKeys = 'mastery_dashboard' | 'drill_enroll' | 'enroll_mastery_bank' | 'wall_of_fame'|'wall_of_fame_grid';

//| 'wall_of_fame'

type ComponentsType = {
  [key in ComponentKeys]: React.ReactNode;
};

function App() {
  const components: ComponentsType = {
    mastery_dashboard: <MasteryDashboard />,
    drill_enroll: <DrillTeam />,
    wall_of_fame: <WallOfFame />,
    enroll_mastery_bank: <MasteryBank />,
    wall_of_fame_grid: <GridLayout/>
    
  };

  const Component = components[COMPONENT as ComponentKeys];

  if (!Component) {
    return <p>No component found for the provided key.</p>;
  }

  return (
    <AppProvider.Provider
      value={{
        token: TOKEN || '',
        type: TYPE || '',
        student_id: STUDENT_ID || '',
        drillTitle: DRILL_TITLE || '',
        fileLink: FILE_LINK || '',
        fileLinkLabel: FILE_LINK_LABEL || '',
        mbTitle: MB_TITLE || '',
        videoUrl: VIDEO_URL || '',
        videoButtonLable: VIDEO_BUTTON_LABEL || '',
        masteryCardLabel: MASTERY_CARD_LABEL || '',
        masteryCardPopupLabel: MASTERY_CARD_POPUP_LABEL || '',
      }}
    >
      {Component}
    </AppProvider.Provider>
  );
}

export default App;
